import React, { useEffect } from 'react';
import FramePlayer from '../utils/FramePlayer';
import anime from 'animejs';
import '../css/module3b.css';
import '../css/common.css';
import lang from '../lang.json';

const Module5d4 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module5d4;

    useEffect(() => {
        var tl = anime.timeline({});
        tl.add({
            targets: '#circle1',
            r: 170,
            duration: 7000,
            easing: 'easeOutElastic(1, .8)',
        }, 200)
            .add({
                targets: '.n1',
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, 200)
            .add({
                targets: '.t1',
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, 900)
            .add({
                targets: '#circle2',
                r: 150,
                duration: 7000,
                easing: 'easeOutElastic(1, .8)',
            }, 1500)
            .add({
                targets: '.n2',
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, 1500)
            .add({
                targets: '.t2',
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, 2400)
            .add({
                targets: '#circle3',
                r: 150,
                duration: 7000,
                easing: 'easeOutElastic(1, .8)',
            }, 3100)
            .add({
                targets: '.n3',
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, 3100)
            .add({
                targets: '.t3',
                opacity: 1,
                duration: 1000,
                easing: 'easeOutElastic(1, .8)',
            }, 4000)
            
    }, []);

    return (
        <div className="background" >

            <FramePlayer dirName="module5d4"
                ext="png"
                frameNumber={53}
                fps={12}
                style={
                    { position: 'absolute', top: '0px', zIndex: 3 }}
            /> <img src={process.env.PUBLIC_URL + "/assets/images/module5d4/1.jpg"}
                style={
                    {
                        position: 'absolute',
                        top: '20px',
                        left: '0px',
                        width: '150px',
                    }
                }
            /> <img src={process.env.PUBLIC_URL + "/assets/images/module5d4/2.jpg"}
                style={
                    {
                        position: 'absolute',
                        top: '105px',
                        left: '510px',
                        width: '150px',
                    }
                }
            /> <img src={process.env.PUBLIC_URL + "/assets/images/module5d4/3.jpg"}
                style={
                    {
                        position: 'absolute',
                        top: '300px',
                        left: '70px',
                        width: '150px',
                        transform: "scale(-1, 1)"
                    }
                }
            /> <svg viewBox="0 0 600 550" >
                <mask id="circles"
                    maskUnits="objectBoundingBox" >
                    <
                        rect x="0"
                        y="0"
                        width="100%"
                        height="100%"
                        fill="white" />
                    <
                        circle id="circle1"
                        cx="85"
                        cy="80"
                        r="0"
                        fill="black" />
                    <
                        circle id="circle2"
                        cx="525"
                        cy="200"
                        r="0"
                        fill="black" />
                    <
                        circle id="circle3"
                        cx="175"
                        cy="370"
                        r="0"
                        fill="black" />
                </mask> <
                    rect x="0"
                    y="18"
                    width="150"
                    height="216"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                /> <
                    rect x="450"
                    y="95"
                    width="150"
                    height="216"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                /> <
                    rect x="63"
                    y="272"
                    width="151"
                    height="171"
                    fill="black"
                    style={
                        { mask: 'url(#circles)' }}
                />
            </svg>

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 0,
                    top: -10,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className='n1'
                style={{
                    position: 'absolute',
                    left: 2,
                    top: 198,
                    color: 'white',
                    fontSize: '13px',
                    opacity: 0
                }}
            >Kurt Gödel (1906 - 1978)</p>
            <p
                className='t1'
                style={{
                    position: 'absolute',
                    left: 164,
                    top: 10,
                    color: 'white',
                    fontSize: '13px',
                    width: '330px',
                    opacity: 0
                }}
            >{texts.lang30}</p>
            <p
                className='n2'
                style={{
                    position: 'absolute',
                    left: 520,
                    top: 74,
                    color: 'white',
                    fontSize: '13px',
                    opacity: 0
                }}
            >Noam Chomsky</p>
            <p
                className='t2'
                style={{
                    position: 'absolute',
                    left: 227,
                    top: 180,
                    color: 'white',
                    fontSize: '13px',
                    width: '200px',
                    opacity: 0
                }}
            >{texts.lang32}</p>
            <p
                className='t3'
                style={{
                    position: 'absolute',
                    left: 312,
                    top: 358,
                    color: 'white',
                    fontSize: '13px',
                    width: '350px',
                    opacity: 0
                }}
            >{texts.lang33}</p>
            <p
                className='n3'
                style={{
                    position: 'absolute',
                    left: 76,
                    top: 266,
                    color: 'white',
                    fontSize: '13px',
                    opacity: 0
                }}
            >Mark Steedman</p>
        </div>
    );
}

export default Module5d4;